import { InputWidthValues } from './types';
import { GzClearableInputWebComponent } from './component/GzClearableInputWebComponent';
import { GzInputSearchWebComponent } from './component/GzInputSearchWebComponent';
import { GzInputNumberWebComponent } from './component/GzInputNumberWebComponent';
import { GzTextareaWebComponent } from './component/GzTextareaWebComponent';

export { InputWidthValues };

export { GzClearableInputWebComponent, GzInputSearchWebComponent, GzInputNumberWebComponent, GzTextareaWebComponent };

/**
 * Examples:
 * Basic text input => <gz-input type="text" placeholder="Name"></gz-input>
 *
 * Basic medium-width text input => <gz-input type="text" placeholder="Name" inputwidth="160"></gz-input>
 *
 * Basic large text input with label =>
 * <gz-input label="Name" type="text" placeholder="Name" inputwidth="240"></gz-input>
 *
 * The label will be displayed inside the input; for the small input size (80px), it's best to add the label outside the
 * input component, as a separate html element component.
 * https://xd.adobe.com/view/039b31a4-3965-488b-a3f7-e6ba5fbcc177-56c8/specs/
 *
 * Basic medium-width email input => <gz-input type="email" placeholder="Email" inputwidth="160"></gz-input>
 *
 * Basic numeric input => <gz-input-number"></gz-input-number>
 *
 * Search input with realtime search event => <gz-input-search placeholder="Search"></gz-input-search>
 *
 * Search input that triggers the search event on ENTER / search button press =>
 * <gz-input-search searchOnAction placeholder="Search"></gz-input-search>
 *
 * Removable search input => <gz-input-search placeholder="Type" label="Threat type" canRemoveInput></gz-input-search>
 */
